import { Flex } from "antd";

import { PrimaryText } from "@/shared/ui/Typography";

export const TooltipTextComponent = () => {
    return (
        <Flex vertical gap={8}>
            <PrimaryText>
                - незалежні ТТ працюватимуть окремо, навіть на одній адресі.
            </PrimaryText>

            <PrimaryText>
                - архівна ТТ повністю виключається з маршрутів, всі її плани та
                прогрес виконання KPI будуть безповоротно видалені
            </PrimaryText>

            <PrimaryText>
                - якщо одна ТТ стає батьківською до іншої, план, прогрес
                виконання KPI та дебіторська заборгованість будуть перенесені на
                нову ТТ
            </PrimaryText>

            <PrimaryText>
                - якщо батьківська і дочірня ТТ належать до різних маршрутів,
                перенос плану може серйозно порушити баланс розподілу планів та
                вплинути на роботу торгової команди
            </PrimaryText>
        </Flex>
    );
};
